import { render, staticRenderFns } from "./OrderCall.vue?vue&type=template&id=590c1d66"
import script from "./OrderCall.vue?vue&type=script&lang=js"
export * from "./OrderCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports